import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './Flute.css';

const NOTE_POSITION = {
  C: ['l1', 'l2', 'l3', 'l4', 'r2', 'r3', 'r4', 'r5'],
  '^C': ['l2', 'l3', 'l4', 'r2', 'r3', 'r4', 'r5-half'],
  D: ['l1', 'l2', 'l3', 'l4', 'r2', 'r3', 'r4'],
  '^D': ['l1', 'l2', 'l3', 'l4', 'r2', 'r3', 'r4-half'],
  E: ['l1', 'l2', 'l3', 'l4', 'r2', 'r3'],
  F: ['l1', 'l2', 'l3', 'l4', 'r2'], 
  '^F': ['l1', 'l2', 'l3', 'l4', 'r3', 'r4', 'r5'],
  G: ['l1', 'l2', 'l3', 'l4'], '^G': ['l1', 'l2', 'l3', 'r2', 'r3', 'r4'],
  A: ['l1', 'l2', 'l3'], '^A': ['l1', 'l2', 'l4', 'r2'],
  _B: ['l1', 'l2', 'l4', 'r2'],
  B: ['l1', 'l2'],
  c: ['l1', 'l3'],'^c': ['l2', 'l3'],
  d: ['l3'],'^d': ['l3', 'l4', 'r2', 'r3', 'r4'],
  e: ['l12', 'l2', 'l3', 'l4', 'r2', 'r3'],
  f: ['l12', 'l2', 'l3', 'l4', 'r2'], '^f': ['l12', 'l2', 'l3', 'l4', 'r3', 'r5'],
  g: ['l12', 'l2', 'l3', 'l4'],'^g': ['l12', 'l2', 'l3', 'l4', 'r3', 'r4', 'r5'],
  a: ['l12', 'l2', 'l3'], '^a': ['l12', 'l2', 'l3', 'l4', 'r2', 'r3', 'r4'],
  b: ['l12', 'l2', 'l3', 'r2', 'r3'],
  '^c': ['l2','l3','l4','r1','r2','r3','r4','r5-half'],
  '^f': ['l1', 'l2', 'l3', 'l4', 'r3', 'r5'],
  '^g':['l1','l2','l3','l4','r3','r4','r5'],
  '^G':['l1','l2','l3','r1','r2'],
  '_E':['l1', 'l2', 'l3', 'l4', 'r2', 'r3', 'r4-half'],
  '_e':['l3','l4','r2','r3','r4'],
  '_G':['l1', 'l2', 'l4', 'l4', 'r2'],
  '_g':['l1','l2','l3','r2','r3','r4'],
};

const SELECTED_KEY_COLOR = "#EC6075";

class Flute extends Component {
  static propTypes = {
    currentNote: PropTypes.object,
    debug: PropTypes.bool
  };

  drawSvg = note => {
    const finger_list = NOTE_POSITION[note];
    return (
      <svg
        width="93.686"
        height="560.5"
        version="1.1"
        id="Livello_1"
        x="0px"
        y="0px"
        viewBox="0 0 93.7 560.5"
        style={{ enableBackground: 'new 0 0 93.7 560.5' }}
      >
        <g id="Group_166" transform="translate(-1723.232 882.728)">
          <path
            id="Path_419"
            className="st0"
            fill="#FFFFFF"
            stroke="#000000"
            d="M1788.3-848.3c0.6-2,0.9-4.1,0.9-6.2c0-15-14.6-27.1-32.7-27.1s-32.7,12.1-32.7,27.1
        c0,2.1,0.3,4.2,0.9,6.3l0.7,2.2l4.7,23c1.9,9.2,2.7,18.5,2.6,27.8l-3,362.5c0,2.7-0.2,5.4-0.5,8.1l-3.2,27.7
        c-1.5,12.9,0.1,25.9,4.6,38l13.5,36.6h24.9l13.5-36.6c4.5-12.1,6-25.2,4.6-38l-3.2-27.7c-0.3-2.7-0.5-5.4-0.5-8.1l-3-362.6
        c-0.1-9.3,0.8-18.6,2.6-27.8l4.7-23.1L1788.3-848.3z"
          />
          <path
            id="Path_420"
            className="st1"
            fill="none"
            stroke="#000000"
            d="M1783.2-449.6c0,9.6-12,17.3-26.8,17.3s-26.8-7.7-26.8-17.3"
          />
          <ellipse
            id="l1"
            cx="1809.9"
            cy="-488"
            rx="7"
            ry="6.9"
            fill={finger_list && finger_list.includes('l1') ? SELECTED_KEY_COLOR : '#000000'}
          />
          <ellipse
            id="l2"
            cx="1757.9"
            cy="-462.7"
            rx="7"
            ry="6.9"
            fill={finger_list && finger_list.includes('l2') ? SELECTED_KEY_COLOR : '#000000'}
          />
          <ellipse
            id="l3"
            cx="1757.9"
            cy="-513.3"
            rx="7"
            ry="6.9"
            fill={finger_list && finger_list.includes('l3') ? SELECTED_KEY_COLOR : '#000000'}
          />
          <ellipse
            id="l4"
            cx="1757.9"
            cy="-563.9"
            rx="7"
            ry="6.9"
            fill={finger_list && finger_list.includes('l4') ? SELECTED_KEY_COLOR : '#000000'}
          />
          <ellipse
            id="r2"
            cx="1757.9"
            cy="-627.7"
            rx="7"
            ry="6.9"
            fill={finger_list && finger_list.includes('r2') ? SELECTED_KEY_COLOR : '#000000'}
          />
          <ellipse
            id="r3"
            cx="1757.9"
            cy="-678.9"
            rx="7"
            ry="6.9"
            fill={finger_list && finger_list.includes('r3') ? SELECTED_KEY_COLOR : '#000000'}
          />
          <ellipse
            id="r4"
            cx="1753.9"
            cy="-730.1"
            rx="7"
            ry="6.9"
            fill={
              finger_list && (finger_list.includes('r4') || finger_list.includes('r4-half')) ? SELECTED_KEY_COLOR : '#000000'
            }
          />
          <circle
            id="r4_small"
            cx="1766.4"
            cy="-730.1"
            r="2.5"
            fill={finger_list && finger_list.includes('r4') ? SELECTED_KEY_COLOR : '#000000'}
          />
          <ellipse
            id="r5"
            cx="1751.9"
            cy="-781.3"
            rx="7"
            ry="6.9"
            fill={
              finger_list && (finger_list.includes('r5') || finger_list.includes('r5-half')) ? SELECTED_KEY_COLOR : '#000000'
            }
          />
          <circle
            id="r5_small"
            cx="1765.4"
            cy="-781.3"
            r="2.5"
            fill={finger_list && finger_list.includes('r5') ? SELECTED_KEY_COLOR : '#000000'}
          />
          <g id="Ellipse_254" transform="translate(1723.307 -377.24)">
            <ellipse className="st2" fill="#19B3B3" cx="33.2" cy="-477.5" rx="33.2" ry="27.5" />
            <ellipse className="st1 piano-footer" stroke="#000000" cx="33.2" cy="-477.5" rx="32.7" ry="27" />
          </g>
          <ellipse id="Ellipse_253" className="st3" stroke="#000000" cx="1756.7" cy="-854.6" rx="23.7" ry="18.1" />
          <path
            id="Path_421"
            d="M1764.8-401.1c0.1,0.4,0.1,0.8,0.1,1.2c0,3.2-2.6,5.8-5.8,5.8h-4.5c-0.4,0-0.8,0-1.2-0.1
        c-3.1-0.7-5.1-3.7-4.5-6.9l2.5-9.8h10.8L1764.8-401.1z"
          />
        </g>
      </svg>
    );
  };

  render() {
    const { currentNote, debug } = this.props;
    const note = currentNote ? currentNote.toAbcString() : null;
    if(note!=null)
      console.log("Flute: ",note)
    return (
      <div>
        {debug && this.renderDebug(note)}
        {this.drawSvg(note)}
      </div>
    );
  }

  renderDebug = note => {
    const isNoteInRange = note && note in NOTE_POSITION;
    return (
      <div>
        {!isNoteInRange && <div>NOTA NON DISPONIBILE</div>}
        <div>FINGER LIST: {isNoteInRange && NOTE_POSITION[note].join(',')}</div>
      </div>
    );
  };
}

export default Flute;
